export default __webpack_public_path__ + "static/history-page-below-harbour-bridge-torn-paper-1d09c7bd9a9eadc102fb97ebcb3ca3d5.png";